import PropTypes from 'prop-types'
import Toast from './Toast'

const ToastsContainer = ({ toasts }) => {
  return (
    <div className="toast-container" style={{position:"fixed"}}>
      {toasts.map((toast) => (
        <Toast key={toast.id} {...toast} />
      ))}
    </div>
  )
}
ToastsContainer.propTypes = {
  toasts: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      message: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
    })
  ).isRequired,
}
export default ToastsContainer
